import { getHeadings } from "@scalar/code-highlight/markdown";
import GithubSlugger from "github-slugger";
const withSlugs = (headings, slugger) => headings.map((heading) => {
  return {
    ...heading,
    slug: slugger.slug(heading.value)
  };
});
function getHeadingsFromMarkdown(input) {
  const slugger = new GithubSlugger();
  const headings = getHeadings(input);
  return withSlugs(headings, slugger);
}
const getLowestHeadingLevel = (headings) => {
  const lowestLevel = Math.min(...headings.map((heading) => heading.depth));
  if (lowestLevel >= 1 && lowestLevel <= 6) {
    return lowestLevel;
  }
  return 1;
};
export {
  getHeadingsFromMarkdown,
  getLowestHeadingLevel
};
//# sourceMappingURL=utils.js.map
